export const HEADERS = { 'Content-Type': 'application/json' };

const defaultOptions = {
  credentials: 'include',
  cache: 'no-cache',
  headers: HEADERS,
};

export const simpleFetch = (uri, options = {}, baseUrl = '') =>
  fetch(`${baseUrl}${uri}`, { ...defaultOptions, ...options })
    .then((response) =>
      response.text().then((text) => {
        try {
          return JSON.parse(text);
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
          return new Error('Something went wrong');
        }
      }),
    )
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Error:', error);
    });

export const simpleFetchWithHttp = (uri, options = {}, baseUrl = '') =>
  fetch(`${baseUrl}${uri}`, { ...defaultOptions, ...options }).catch((error) => {
    // eslint-disable-next-line no-console
    console.error('Error:', error);
  });
